import styled from "styled-components";

import { Card } from "b2c/components/Core";

export const StyledCard = styled(Card)`
  margin: 0 10px 0;
  padding: 16px;
  position: relative;
`;
